import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, FileText } from "lucide-react";
import api from "@/lib/api";
import { fileUrl } from "@/lib/upload";
import { ContactLinks } from "@/components/ContestRules";
import Logo from "@/components/Logo";

const GENERIC = "";

export default function PublicPrivacy() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [g, setG] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { if (id) api.contestPublic(id).then(setC).catch(() => setErr(true)); api.privacySettings().then(setG).catch(() => setG({ text: GENERIC, title: "Informativa privacy" })); }, [id]);
  const logo = c ? fileUrl(c.logo_file_id) || c.logo_url : null;
  const specific = !!(c?.privacy_text || c?.privacy_file_id);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="public-privacy-page">
      <header className="border-b border-border"><div className="max-w-2xl mx-auto px-5 py-4 flex items-center gap-3"><Logo className="h-10" /><div><p className="text-xs uppercase tracking-widest text-primary font-semibold">Informativa privacy</p><h1 className="font-display font-bold text-lg">{id ? (c?.name || (err ? "Concorso non trovato" : "Caricamento…")) : "Vivi Win"}</h1></div></div></header>
      {(!id || c || err) && (
        <main className="max-w-2xl mx-auto px-5 py-8 space-y-6">
          {logo && <img src={logo} alt="" className="h-16 w-auto object-contain rounded-xl bg-white p-1" />}
          {c?.privacy_file_id && (
            <a href={fileUrl(c.privacy_file_id)} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 hover:border-primary" data-testid="public-privacy-pdf">
              <span className="h-11 w-11 rounded-xl bg-primary/15 grid place-items-center"><FileText className="h-5 w-5 text-primary" /></span>
              <div><p className="font-semibold">Informativa privacy completa (PDF)</p><p className="text-xs text-muted-foreground">Tocca per aprire o scaricare</p></div>
            </a>
          )}
          {c?.privacy_text && (
            <section className="rounded-2xl border border-border bg-card p-5" data-testid="public-privacy-text">
              <h2 className="font-semibold flex items-center gap-2 mb-3"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Informativa privacy</h2>
              <p className="text-sm whitespace-pre-wrap leading-relaxed">{c.privacy_text}</p>
            </section>
          )}
          {!specific && g && (
            <section className="rounded-2xl border border-border bg-card p-5" data-testid="public-privacy-generic">
              <h2 className="font-semibold flex items-center gap-2 mb-3"><ShieldCheck className="h-4 w-4 text-emerald-400" /> {g.title || "Informativa privacy"}</h2>
              <p className="text-sm whitespace-pre-wrap leading-relaxed">{g.text}</p>
              {g.holder && <p className="text-xs text-muted-foreground mt-3">Titolare del trattamento: {g.holder}</p>}
            </section>
          )}
          {c && (c.contact_email || c.contact_phone) && <section className="rounded-2xl border border-border bg-card p-5 space-y-2"><h2 className="font-semibold">Contatti del titolare</h2><ContactLinks c={c} /></section>}
          {c && <a href={`/regolamento/${c.id}`} className="inline-block text-sm underline text-primary" data-testid="public-privacy-rules-link">Leggi il regolamento del concorso</a>}
        </main>
      )}
    </div>
  );
}
